import { useCallback } from 'react';

import { useReorderInspectionTemplate } from 'react-hooks';

import { buildReorderParams, type ReorderInput } from './buildReorderParams';
import type { MutationContext } from './mutationLane';

export type ReorderTemplate = (
  input: ReorderInput,
  context: MutationContext
) => Promise<number>;

// `context.baseVersion` is not sent yet: it is the hook point for the
// expected version (TS-55794)
export function useReorderTemplate(): ReorderTemplate {
  const { reorderInspectionTemplate } = useReorderInspectionTemplate();

  return useCallback<ReorderTemplate>(
    async input => {
      const params = buildReorderParams(input);
      const { newVersion } = await reorderInspectionTemplate(params);

      return newVersion;
    },
    [reorderInspectionTemplate]
  );
}
